import { createContext } from 'react';

export const dependenciesFieldPathsContext = createContext<string[]>([]);
